import { render, staticRenderFns } from "./UserDashboardDeliveryCardDetailsModal.vue?vue&type=template&id=a88e0864&"
import script from "./UserDashboardDeliveryCardDetailsModal.vue?vue&type=script&lang=js&"
export * from "./UserDashboardDeliveryCardDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VApp,VBtn,VImg})
